import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Fellowship from "@/pages/Fellowship";
import WordStudy from "@/pages/WordStudy";
import ReadBible from "@/pages/ReadBible";
import Media from "@/pages/Media";
import MapsAdmin from "@/pages/MapsAdmin";
import MapGallery from "@/pages/MapGallery";
import RequestTracker from "@/pages/RequestTracker";
import ContactInbox from "@/pages/ContactInbox";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-parchment parchment-texture">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fellowship" element={<Fellowship />} />
            <Route path="/word-study" element={<WordStudy />} />
            <Route path="/read" element={<ReadBible />} />
            <Route path="/media" element={<Media />} />
            <Route path="/maps-admin" element={<MapsAdmin />} />
            <Route path="/bible-maps" element={<MapGallery />} />
            <Route path="/bible-requests" element={<RequestTracker />} />
            <Route path="/contact-inbox" element={<ContactInbox />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
